import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=5a4510e4&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=5a4510e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4510e4",
  null
  
)

export default component.exports